import { Box } from '@mui/material'
import { ReactComponent as InputDeleteLogo } from 'assets/input_delete_logo.svg'
import { memo } from 'react'
import { COLORS } from 'styles/colors'
import { ChipItem } from 'ui/ChipItem'

interface BreadCrumbsProps {
	handleActiveFilter: (id: string | number) => void
	handleRemoveFilter?: (id: string | number) => void
	array?: {
		title: string
		id: number | string
		disabled?: boolean
		selected?: boolean
	}[]
	allLabel?: string
}

const BreadCrumbsGroup = memo((props: BreadCrumbsProps) => {
	const { handleActiveFilter, handleRemoveFilter, array = [], allLabel } = props

	const selectedIds = (array ?? []).filter(el => el.selected).map(el => el.id)

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				gap: '8px',
				flexWrap: 'wrap',
			}}
		>
			{allLabel && (
				<ChipItem
					onClick={() => {
						selectedIds.forEach(id => handleRemoveFilter?.(id))
						handleActiveFilter('all')
					}}
					sx={{
						cursor: 'pointer',
						backgroundColor: selectedIds.length === 0 && COLORS.main,
						color: selectedIds.length === 0 && '#fff',
					}}
					label={allLabel}
				/>
			)}
			{(array ?? []).map(el => {
				const isSelected = el.selected

				return (
					<ChipItem
						key={el.id}
						disabled={el.disabled}
						onClick={() => {
							if (el.disabled) return
							handleActiveFilter(el.id)
						}}
						onDelete={
							isSelected && handleRemoveFilter
								? () => handleRemoveFilter(el.id)
								: undefined
						}
						deleteIcon={
							isSelected ? (
								<InputDeleteLogo style={{ color: '#fff' }} />
							) : undefined
						}
						sx={{
							cursor: el.disabled ? 'default' : 'pointer',
							backgroundColor: isSelected && COLORS.main,
							color: isSelected && '#fff',
						}}
						label={el.title}
					/>
				)
			})}
		</Box>
	)
})

export default BreadCrumbsGroup

BreadCrumbsGroup.displayName = 'BreadCrumbsGroup'
